<template>
  <div>
    <ul class="study-type clearfix">
      <li
        :class="{ active: item.key === studyTab.key }"
        v-for="(item, index) in studyTabList"
        :key="index"
        @click="changeTab(item)"
      >
        <div class="study-type-title">{{ item.title }}</div>
      </li>
    </ul>
    <chapter-practice
      v-if="studyTab.key === 1"
      :cstId="course.cstid"
    ></chapter-practice>
    <sim-exam v-if="studyTab.key == 2" :type="1" key="exam2"></sim-exam>
    <sim-exam v-if="studyTab.key == 3" :type="4" key="exam3"></sim-exam>
    <div
      v-for="(item, index) in studyTabList.filter(m => m.key >= 4)"
      :key="index"
    >
      <review
        v-if="studyTab.key === item.key"
        :cstId="item.cstId"
        :reviewUmcId="item.umcId"
      ></review>
    </div>
  </div>
</template>
<script>
import { siteMixin } from '../../../utils/mixin';
import ChapterPractice from './ChapterPractice';
import SimExam from './SimExam';
import Review from './Review';
export default {
  mixins: [siteMixin],
  props: {
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      studyTab: {},
      studyTabList: [],
    };
  },
  mounted() {
    this.initTabData();

    //定制化跳转的滚动处理
    const custom = this.$route.query.e;
    if (custom && custom == 'x') {
      setTimeout(() => {
        this.changeTab(this.studyTabList.find(m => m.key == 2 || x.key == 3));
      }, 300);
    }
  },
  methods: {
    initTabData() {
      if (this.course.isPractice) {
        this.studyTabList.push({
          key: 1,
          title: '章节练习',
          cstId: 0,
          expire: 0,
        });
      }
      if (this.course.isSimExam) {
        if ([4688].includes(this.siteConfig.agencyId)) {
          this.studyTabList.push({
            key: 2,
            title: '考 试',
            cstId: 0,
            expire: 0,
          });
        } else {
          this.studyTabList.push({
            key: 2,
            title: '模拟试题',
            cstId: 0,
            expire: 0,
          });
        }
      }
      if (this.course.isHtExam) {
        this.studyTabList.push({
          key: 3,
          title: '期末考试',
          cstId: 0,
          expire: 0,
        });
      }
      if (
        this.course.courseSpecialTypes &&
        this.course.courseSpecialTypes.length > 0
      ) {
        let tabList = this.course.courseSpecialTypes.map((item, index) => {
          let result = {};
          result.key = index + 4;
          result.title = item.specialName;
          result.cstId = item.id;
          result.umcId = item.umcId;
          result.expire = item.isExpire;
          return result;
        });
        this.studyTabList = [...this.studyTabList, ...tabList];
      }
      if (this.studyTabList.length > 0) {
        this.studyTab = this.studyTabList[0];
      }
    },
    changeTab(item) {
      if (item.expire === 1) {
        this.$emit('on-expire');
        return;
      }
      this.studyTab = item;
    },
  },
  components: {
    ChapterPractice,
    SimExam,
    Review,
  },
};
</script>
<style lang="less" scoped>
@import '../../../assets/css/var.less';
@import '../../../assets/css/study.less';
.study-type {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
  li {
    text-align: center;
    font-weight: bold;
    color: #666;
    padding: 5px 20px 10px 20px;
    margin-right: 30px;
    cursor: pointer;
    font-size: 22px;
    &::after {
      content: ' ';
      display: block;
      margin: 5px auto 0 auto;
      width: 90px;
      height: 5px;
      background: #fff;
    }
    &:hover {
      color: #2595fd;
    }
    &.active {
      color: #2595fd;
      &::after {
        background: linear-gradient(#27a4ff 21.43%, #227efa 95.7%);
      }
    }
  }
}
</style>
